import { gql } from 'graphql-request';
import { useQueryApplication } from 'src/graphqlhooks';
import { getNamespaceName } from '../objects/namespaces';

export const GET_POD_CONFIG_BY_EMAIL = `pod_configs(where: {object_meta: {_contains: $objectMeta} _and:{assignees: {_contains: $assignees}}}) {
  id
  name
  assignees
  priority
  object_meta
  rule
  type_of_loan
  created_at
}
`;
export const GET_POD_CONFIG_FOR_NAMESPACE = gql`
  query pod_configs($objectMeta: jsonb, $rules: jsonb) {
    pod_configs(where: { rule: { _contains: $rules }, object_meta: { _contains: $objectMeta } }) {
      id
      name
      assignees
      priority
      object_meta
      rule
      type_of_loan
      created_at
    }
  }
`;
const getPodConfigBasedOnLendingLimit = () => {
  return {
    rules: [
      {
        varmap_name: "mortgage_loan_amount",
        rule_type: "boundary"
      }
    ]
  }
}

export const GQLGetPodConfigFortheNamespace = () => {
  const { data, loading } = useQueryApplication(GET_POD_CONFIG_FOR_NAMESPACE, {
    variables: {
      objectMeta: { namespace: getNamespaceName() },
      rules: getPodConfigBasedOnLendingLimit()
    },
  });
  return { data, loading };
};

export const GET_USER_POD_CONFIG_BY_EMAIL = gql`query describeISOConfigByEmail($objectMeta: jsonb, $assignees: jsonb) {
  ${GET_POD_CONFIG_BY_EMAIL}
}`;

export const GET_POD_CONFIG_BY_ISO = gql`query describePodConfigByISO($objectMeta: jsonb, $rule: jsonb) {
  pod_configs(where: {object_meta: {_contains: $objectMeta} _and:{rule: {_contains: $rule}}}) {
  id
  name
  assignees
  priority
  object_meta
  rule
  type_of_loan
  created_at
}
}`;



export const CREATE_OR_UPDATE_POD_CONFIG = `mutation createOrUpdatePodConfig($data: [pod_configs_insert_input!]!) {
    insert_pod_configs(objects: $data, on_conflict: {constraint: pod_configs_pkey, update_columns: [name,assignees,priority,rule,object_meta]}) {
        returning {
          created_at
          id
          priority
        }
      }
    }`


export const DELETE_POD_CONFIG = `mutation deletePodConfig($objectMeta: jsonb, $assignees: jsonb) {
    delete_pod_configs(where: {object_meta: {_contains: $objectMeta} _and:{assignees: {_contains: $assignees}}}) {
    affected_rows
    }
  }`

export const DELETE_POD_CONFIG_BY_ID = `mutation deletePodConfig($uids: [bigint]) {
    delete_pod_configs(where: {id: {_in: $uids}}) {
    affected_rows
    }
  }`
